
import React from 'react';
import { Slider } from "@/components/ui/slider";

interface FrequencySliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  label?: string;
  description?: string;
  hideDescription?: boolean;
}

// Helper function to get a descriptive label based on frequency
export const getFrequencyDescription = (freq: number): string => {
  if (freq <= 4) return "Deep sleep";
  if (freq <= 8) return "Meditation, creativity";
  if (freq <= 13) return "Relaxation, calmness";
  if (freq <= 30) return "Focus, alertness";
  return "High cognitive activity";
};

export const getBrainwaveCategory = (freq: number): string => {
  if (freq <= 4) return "Delta";
  if (freq <= 8) return "Theta";
  if (freq <= 13) return "Alpha";
  if (freq <= 30) return "Beta";
  return "Gamma";
};

export const getBrainwaveCategoryColor = (category: string): string => {
  switch (category) {
    case "Delta": return "bg-blue-500";
    case "Theta": return "bg-indigo-500";
    case "Alpha": return "bg-green-500";
    case "Beta": return "bg-yellow-500";
    case "Gamma": return "bg-red-500";
    default: return "bg-gray-500";
  }
};

const FrequencySlider: React.FC<FrequencySliderProps> = ({
  value,
  onChange,
  min = 0.5,
  max = 40,
  step = 0.5,
  label = "Frequency",
  description,
  hideDescription = false
}) => {
  return (
    <div className="space-y-4 w-full animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-medium">{label}</h3>
          {/* Removed the description that was here */}
        </div>
        <span className="text-sm font-mono">{value.toFixed(1)} Hz</span>
      </div>
      
      <Slider
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(values) => onChange(values[0])}
        className="py-1"
      />
      
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{min} Hz</span>
        <span>{max} Hz</span>
      </div>
    </div>
  );
};

export default FrequencySlider;
